import moment from "moment-timezone";

moment.locale("de")
moment.weekdays(true)
moment.tz.setDefault('Europe/Berlin')

function formatDate(value) {
    if (value) {
        return moment(value).format('DD.MM.YYYY');
    }
    return '---';
}

function formatWeekDay(value) {
    if (value) {
        return value.substring(0,3)
    }
    return '---';
}


function formatDateWithWeekday(value) {
    if (value) {
        return moment(value).format('dd, DD.MM.YYYY');
    }
    return '---';
}

function formatDateForUri(value) {
    if (value) {
        return moment(value).format('YYYY-MM-DD');
    }
    return '---';
}

function formatTimeString(value) {
    if (value) {
        return moment(value, 'HH:mm:ss').format('HH:mm');
    }
    return '---';
}

export default {
    formatDate: formatDate,
    formatDateWithWeekday: formatDateWithWeekday,
    formatDateForUri: formatDateForUri,
    formatTimeString: formatTimeString,
    formatWeekDay: formatWeekDay,
}
